import type { FC } from "react";
import { Link, useLocation } from "react-router-dom";
import { APP_ROUTES } from "@src/core/constants";
import { SidebarWrapper, SidebarLink, SidebarSection } from "./sidebar.styles";
import { ReactComponent as AddIcon } from "@src/core/icons/add.svg";
import { ReactComponent as SettingsIcon } from "@src/core/icons/settings.svg";
import { useThemeMode } from "@src/core/theme";

export const Sidebar: FC = () => {
  const { pathname } = useLocation();
  const { mode, toggleTheme } = useThemeMode();

  const isActive = (route: string) => pathname.startsWith(route);

  return (
    <SidebarWrapper>
      <SidebarSection>Основное</SidebarSection>
      <SidebarLink active={pathname === APP_ROUTES.DASHBOARD}>
        <Link to={APP_ROUTES.DASHBOARD}>
          <span>Панель управления</span>
        </Link>
      </SidebarLink>
      <SidebarLink active={isActive(APP_ROUTES.WORKSPACE)}>
        <Link to={APP_ROUTES.WORKSPACE}>
          <AddIcon />
          <span>Пространства</span>
        </Link>
      </SidebarLink>
      <SidebarLink active={pathname === APP_ROUTES.LOGS || isActive(APP_ROUTES.LOG)}>
        <Link to={APP_ROUTES.LOGS}>
          <span>Журнал запросов</span>
        </Link>
      </SidebarLink>

      <SidebarSection>Аккаунт</SidebarSection>
      <SidebarLink active={pathname === APP_ROUTES.SETTINGS}>
        <Link to={APP_ROUTES.SETTINGS}>
          <SettingsIcon />
          <span>Настройки</span>
        </Link>
      </SidebarLink>
      <SidebarLink active={pathname === APP_ROUTES.CONNECT}>
        <Link to={APP_ROUTES.CONNECT}>
          <span>Агенты (MCP)</span>
        </Link>
      </SidebarLink>
      <SidebarLink active={false}>
        <Link to={APP_ROUTES.JSON_VALIDATOR}>
          <span>JSON Валидатор</span>
        </Link>
      </SidebarLink>

      <SidebarSection>Оформление</SidebarSection>
      <SidebarLink active={false}>
        <span onClick={toggleTheme} style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "12px", width: "100%" }}>
          <span>{mode === "light" ? "🌙" : "☀️"}</span>
          <span>{mode === "light" ? "Тёмная тема" : "Светлая тема"}</span>
        </span>
      </SidebarLink>
    </SidebarWrapper>
  );
};
